/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"

import { Link } from "./Link"
import {
  colors,
  flex,
  onSupport,
  TOUCH_TARGET,
  withTrimMarkMotif,
  White100Type,
} from "../styles"
import { LogoMarkCircle } from "./LogoMarkCircle"
import { PaperMotif } from "./PaperMotif"
import { useToggleSwitch } from "../hooks/useToggle"
import ContentArea from "./ContentArea"
import { MenuButton } from "./MenuButton"

export const Menu = props => {
  const [toggled, handleToggle] = useToggleSwitch(false)
  const TouchBoundary = `calc(${TOUCH_TARGET} / 2)`

  return (
    <nav
      css={{
        position: "fixed",
        zIndex: 99,
        width: "100vw",
        // height: TOUCH_TARGET,
        overflow: "visible",

        ...flex("row"),
        justifyContent: "space-between",
      }}
    >
      <PaperMotif
        css={[
          // !toggled && {
          //   visibility: "hidden",
          //   opacity: 0,
          //   pointerEvents: "none",
          // },
          { visibility: "hidden" },
        ]}
      >
        <Link to={"/"} css={{ display: "block" }}>
          <LogoMarkCircle
            color={colors.BLUE}
            css={{ maxWidth: TOUCH_TARGET }}
          />
        </Link>
      </PaperMotif>

      <PaperMotif css={[toggled && { backgroundColor: "transparent" }]}>
        <MenuButton onClick={handleToggle} toggled={toggled} />
      </PaperMotif>

      <div
        css={[
          {
            zIndex: -1,
            position: "absolute",
            width: "100vw",
            height: "100vh",
          },
          !toggled && { opacity: 0, pointerEvents: "none" },
        ]}
      >
        <div
          css={[
            {
              // zIndex: -1,
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              // pointerEvents: "none",
              backgroundColor: "hsl(0,0%,1%,1)",
              opacity: 0.9,
            },
            onSupport("backdrop-filter: blur(1px)", {
              backgroundColor: "hsl(0,0%,1%,1)",
              opacity: 0.85,
              backdropFilter: "blur(0.5rem)",
            }),
          ]}
        ></div>
        <ContentArea
          css={{
            zIndex: 0,
            position: "absolute",
            right: 0,
            padding: TOUCH_TARGET,

            // margin: TouchBoundary,
            color: colors.PAPER_WHITE,
            ...flex("column"),
            alignItems: "flex-end",
          }}
        >
          {[
            // ["Services", "/services"],
            // ["Mailing", "/mailing"],
            // ["Realty", "/realty"],
            ["Promo", "https://mysticparker.espwebsite.com/"],
            // ["*404*", "/404"],
          ].map(([label, href]) => (
            <Link
              key={label}
              css={{
                ...White100Type,

                margin: TouchBoundary,
                padding: "0.25rem",
                "&.active-link": withTrimMarkMotif,
              }}
              to={href}
            >
              {label}
            </Link>
          ))}
        </ContentArea>
      </div>
    </nav>
  )
}

export default Menu
